import { type FunctionComponent } from 'react';
import { type ProductVariantFieldsFragment } from '../../../__generated__/graphql-client-types';
import { StyledLink } from '../../common-components/link/styled-link.component';

export type ManufacturerNumbersProps = {
	brandName: string;
	variants: ProductVariantFieldsFragment[];
};

export const ManufacturerNumbers: FunctionComponent<ManufacturerNumbersProps> = ({ brandName, variants }) => {
	const hasDiscontinuedVariant = variants.some((variant) => variant.status === 'discontinued');
	return (
		<div>
			<p>This product is listed under the following manufacturer number(s):</p>
			<ul className="list flex flex-wrap pa0">
				{variants.map((variant) => (
					<li key={variant.id} className="w-50 w-third-ns mt1 ph3">
						<StyledLink url={variant.url}>
							{brandName} {variant.modelNumber}
						</StyledLink>
						{variant.status === 'discontinued' && <span className="ml1">*</span>}
						<p className="f7">{variant.title}</p>
					</li>
				))}
			</ul>
			{hasDiscontinuedVariant && <p className="f6">*Denotes a finish or option that has been discontinued.</p>}
		</div>
	);
};
